//  small trick to be able to run test with mocha..
// var XMLHttpRequest = require('xmlhttprequest').XMLHttpRequest;
import {URLRequest} from "./URLRequest";
import { CREATEJS_UTILITIES_LOGGER } from "../../../../..";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".URLLoaderService");

/**
 * this is basically just wrapping the XMLHttpRequest with a promise
 * it is currently used to load xml or json and works fine but it is probably better to
 * TODO @HTML5 find better implementation / npm module that promisify the XmlHttpRequest
 *
 * check also for redundancy with Loader and URLLoader classes in same package
 */

export class URLLoaderService {

    private request: XMLHttpRequest | undefined;
    private resolve: ((value?: any) => void) | undefined;
    private reject: ((reason?: any) => void) | undefined;

    constructor(private urlRequest: URLRequest) {
        this.request = new XMLHttpRequest();
        this.request.open(this.urlRequest.method, this.urlRequest.url, true);
        this.request.onload = this.onload;
        this.request.onerror = this.onerror;
    }

    public load(): Promise<any> {
        const request = this.request;
        if (!request) {
            return Promise.reject(new Error(`this.request was already disposed (undefined)`));
        }

        return new Promise<any>((resolve, reject) => {
            logger.debug(`URLLoaderService.load: ${this.urlRequest.method} request.sent to ${this.urlRequest.url}`);
            request.send(this.urlRequest.data);
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    public dispose() {
        if (this.request) {
            this.request.onload = () => {};
            this.request.onerror = () => {};
            this.request = undefined;
        }
        this.resolve = undefined;
        this.reject = undefined;
    }

    private onload = () => {
        if (!this.request || !this.resolve || !this.reject) {
            throw new Error(`Already disposed`);
        }

        if (this.request.status >= 200 && this.request.status < 300) {
            logger.debug("SUCCESS: " ,this.request["responseURL"], this.request.status);
            this.resolve(this.request.responseText);
        } else {
            logger.warn("FAILURE:", this.request["responseURL"], this.request.status, this.request.responseText);
            this.reject(false);
        }
    }

    private onerror = (event: ErrorEvent) => {
        if (!this.reject) {
            throw new Error(`Already disposed`);
        }

        logger.error("ERROR:", event);
        this.reject(event);
    }
}
